/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
/* eslint-disable no-nested-ternary */
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { MaestroAPI, maestroApiCall } from '@michelin/central-provider';
import { baseURL } from 'Types/APITypes';
import { CommercialLocation } from 'components/Commercial/Fields';
import { QueryKeys } from 'Types';

const getLocation = (stNumber: string) => maestroApiCall({ method: 'GET', endpoint: `locations/${stNumber}/commercial-location`, baseURL }).then((data) => {
  data.google_places = {
    google_places_id: data.google_places_id,
    geo_code_latitude: data.service_address_latitude,
    geo_code_longitude: data.service_address_longitude,
    requested_geo_code_explanation: data.requested_geo_code_explanation,
    requested_geo_code_latitude: data.requested_geo_code_latitude,
    requested_geo_code_longitude: data.requested_geo_code_longitude,
    requested_geo_code_update: data.requested_geo_code_update,
  };
  data.st_phone = data.st_phone ? (!data.st_phone.startsWith('+') ? `+1${data.st_phone}` : data.st_phone) : '';
  data.toll_free_number = data.toll_free_number ? (!data.toll_free_number.startsWith('+') ? `+1${data.toll_free_number}` : data.toll_free_number) : '';
  data.after_hours_phone_number = data.after_hours_phone_number ? (!data.after_hours_phone_number.startsWith('+') ? `+1${data.after_hours_phone_number}` : data.after_hours_phone_number) : '';
  data.secondary_after_hours_phone_number = data.secondary_after_hours_phone_number ? (!data.secondary_after_hours_phone_number.startsWith('+') ? `+1${data.secondary_after_hours_phone_number}` : data.secondary_after_hours_phone_number) : '';
  return data;
});

export default function useCommercialLocation(stNumber: string) {
  return useQuery<CommercialLocation>([QueryKeys.commercialLocation, stNumber], () => getLocation(stNumber));
}

interface saveParams {
  stNumber: string,
  data: CommercialLocation
}

async function saveCommercialLocation({ stNumber, data }: saveParams) {
  const apiType: MaestroAPI = { method: 'PUT', endpoint: `locations/${stNumber}/commercial-location`, baseURL };
  const newData: CommercialLocation = { ...data, ...data.google_places };

  newData.service_address_latitude = data.google_places?.geo_code_latitude;
  newData.service_address_longitude = data.google_places?.geo_code_longitude;
  newData.service_radius = data.service_radius.toString();

  // Remove the extra data in the entity.
  delete newData.county;
  delete newData.google_places;
  delete newData.geo_code_latitude;
  delete newData.geo_code_longitude;
  delete newData.validations;

  const res = await maestroApiCall(apiType, newData);
  return res;
}

export function useSaveCommercialLocation(stNumber: string) {
  const queryClient = useQueryClient();
  return useMutation(saveCommercialLocation, {
    onSuccess: () => {
      queryClient.invalidateQueries([QueryKeys.commercialLocation, stNumber]);
    },
  });
}
